import React, { useState, useEffect } from 'react'

import Background     from './Background'
import Impact         from './goal/Impact'
import Goal           from './goal/Goal'
import DonationsFull  from './donations/DonationsFull'
import TTD            from './TTD'
import QRCode         from './QRCode'
import PoweredBy      from './PoweredBy'

import Drawer         from './edit/Drawer'
import useLiveEdit    from './edit/useLiveEdit'
import useFullscreen  from './useFullscreen'

const App = ({
  textToDonate, qrUrl, hideFeed, fancyBackgrounds, impactColors,
  imageUpload, liveEditUI, tieredDonations, ...props
}) => {
  const [ flp, setFlp ] = useState(props.fundraiser)
  const [ impactWidget, setImpactWidget ] = useState(props.impactWidget)
  const [ orders, setOrders ] = useState(props.orders)

  const { fullscreen, toggleFullscreen, iPadFullscreen } = useFullscreen()
  const liveEdit = useLiveEdit({ ...imageUpload, config: props.config })
  const config = liveEdit.state

  const first_id = orders[0]?.id || ''

  const fetchDonations = () => {
    const url = [ location.pathname, new URLSearchParams({ first_id }) ].join('?')

    const success = data => {
      setFlp(data.fundraiser)
      setImpactWidget(data.impact_widget)
      setOrders(orders =>
        data.orders.concat(orders).slice(0, Math.max(data.orders.length, 6))
      )
    }

    fetch(url, { headers: { Accept: 'application/json' } })
    .then(response => response.json()).then(success)
  }

  useEffect(() => {
    const interval = setInterval(fetchDonations, 15000)
    return () => clearInterval(interval)
  }, [ first_id ])

  return (
    <div className="h-100 d-flex">
      <Background
        config={config}
        fancyBackgrounds={fancyBackgrounds}
        impactColors={impactColors}
      />

      <div className="flex-fill d-flex flex-column align-items-start gap-2 p-2">
        <div style={iPadFullscreen ? { marginLeft: 'calc(100px - 0.5rem)' } : null}>
          {
            impactWidget
            ? <Impact
                {...impactWidget}
                goal={flp.goal} // replace with goal on impact widget later
              />
            : <Goal {...flp} />
          }
        </div>

        <Drawer
          {...liveEditUI}
          {...liveEdit}
          fullscreen={fullscreen}
          toggleFullscreen={toggleFullscreen}
          fancyBackgrounds={fancyBackgrounds}
          impactColors={impactColors}
          textToDonate={textToDonate}
        />

        <div className="flex-fill"></div>

        {
          config.display_qr_code &&
          <QRCode config={config} qrUrl={qrUrl} />
        }

        {
          config.display_ttd && textToDonate &&
          <TTD textToDonate={textToDonate} />
        }
      </div>

      {
        hideFeed
        ? <div className="d-flex flex-column-reverse p-2">
            <div className="overlay rounded-3 px-2 pb-1">
              <PoweredBy />
            </div>
          </div>
        : <DonationsFull orders={orders} config={config} tieredDonations={tieredDonations} />
      }
    </div>
  )
}

export default App
